import { alpha } from '@mui/material/styles';

const TOAST_SEVERITIES = ['success', 'info', 'warning', 'error'];

// ==============================|| OVERRIDES - ALERT ||============================== //

export default function Alert(theme) {
    const baseToastStyle = {
        display: 'flex',
        alignItems: 'center',
        width: 'fit-content',
        maxWidth: 'calc(100vw - 32px)',
        fontSize: '0.75rem',
        paddingTop: theme.spacing(0.25),
        paddingBottom: theme.spacing(0.25),
        paddingLeft: theme.spacing(0.75),
        paddingRight: theme.spacing(0.75),
        minHeight: 24,
        boxShadow: `0 8px 28px ${alpha(theme.palette.common.black, 0.2)}`,
        borderRadius: '10px',
        '& .MuiAlert-message': {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            padding: 0,
            margin: 0,
            lineHeight: 1.3
        },
        '& .MuiAlert-icon': {
            padding: 0,
            margin: 0,
            marginRight: theme.spacing(0.5),
            display: 'flex',
            alignItems: 'center',
            alignSelf: 'center',
            '& svg': {
                display: 'block',
                fontSize: '0.85rem'
            }
        },
        '& .MuiAlert-action': {
            display: 'flex',
            alignItems: 'center',
            alignSelf: 'center',
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: theme.spacing(0.5),
            marginRight: 0,
            whiteSpace: 'nowrap'
        }
    };

    const filledToastStyles = TOAST_SEVERITIES.reduce((styles, severity) => {
        const mainColor = theme.palette[severity].main;
        return {
            ...styles,
            [`&.MuiAlert-filled${severity.charAt(0).toUpperCase()}${severity.slice(1)}`]: {
                color: theme.palette.common.white,
                backgroundColor: alpha(mainColor, 0.92),
                border: `1px solid ${alpha(mainColor, 0.98)}`
            }
        };
    }, {});

    return {
        MuiAlert: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    ...(ownerState.variant === 'filled' && {
                        '.MuiSnackbar-root &': {
                            ...baseToastStyle,
                            ...filledToastStyles
                        }
                    })
                })
            }
        }
    };
}
